import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description: Transform fieldMessages property in a FieldMessageBean into something we can
dispatch to the redux store in the applyFieldChanges action.
*/
import getFieldKey from '../../../../form/get-field-key';
export default (function (_ref) {
  var formId = _ref.formId,
      fields = _ref.fields,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages;
  return messages // strip out any field messages that don't have at least one entry in the fieldNames array
  .filter(function (message) {
    return message.fieldNames && message.fieldNames.length;
  }) // generate and collect one fieldMessage object per entry in the fieldNames array
  .reduce(function (fieldMessages, _ref2) {
    var fieldNames = _ref2.fieldNames,
        message = _ref2.message,
        level = _ref2.level,
        systemError = _ref2.systemError,
        messagePlacement = _ref2.messagePlacement;
    return fieldMessages.concat(fieldNames.map(function (fieldName) {
      return {
        fieldName: fieldName,
        message: message,
        level: level,
        systemError: systemError,
        messagePlacement: messagePlacement
      };
    }));
  }, []) // remove any fieldMessage object that doesn't have a corresponding field definition in the redux store
  .filter(function (_ref3) {
    var fieldName = _ref3.fieldName;
    return fields.get(getFieldKey({
      formId: formId,
      fieldId: fieldName
    }));
  }) // generate objects we can dispatch to teh applyFieldChanges
  .map(function (_ref4) {
    var fieldName = _ref4.fieldName,
        message = _ref4.message,
        level = _ref4.level;
    return {
      fieldKey: getFieldKey({
        formId: formId,
        fieldId: fieldName
      }),
      serverMessage: message,
      serverMessageLevel: level,
      showError: true
    };
  });
}); // Sample JSON response from server
// {
//   "FailureMessageBean": {
//     "globalMessages": [
//       {
//         "fieldNames": [],
//         "level": "ERROR",
//         "message": "Please check the highlighted fields below.",
//         "systemError": false
//       }
//     ],
//       "fieldMessages": [
//         {
//           "fieldNames": [
//             "recipientFirstName",
//             "firstName"
//           ],
//           "message": "Please enter a valid first name.",
//           "level": "ERROR",
//           "systemError": false,
//           "messagePlacement": "DEFAULT",
//         }
//       ]
//   },
//   "viewName": "failureResponse"
// }